import { ref, remove, update } from "firebase/database";
import { database, serverValue } from "services/firebaseService/firebaseConfig";
// eslint-disable-next-line you-dont-need-lodash-underscore/is-undefined
import { isUndefined, omitBy } from "lodash";
import { Announcement } from "./types";

export const ANNOUNCEMENT_PATH = "Announcement";

const getAnnouncementDocRef = (channel: string) =>
  ref(database, `${ANNOUNCEMENT_PATH}/${channel}`);

const sendMessage = (channel: string, announcement: Announcement) => {
  const docRef = getAnnouncementDocRef(channel);
  const announcementWithoutUndefinedProps = omitBy(announcement, isUndefined);

  update(docRef, {
    ...announcementWithoutUndefinedProps,
    sentAt: serverValue.TIMESTAMP,
  });
};

const clearChannel = (channel: string) => {
  const docRef = getAnnouncementDocRef(channel);
  remove(docRef);
};

export default {
  getAnnouncementDocRef,
  clearChannel,
  sendMessage,
};
